import { ApolloLink } from "@apollo/client"
import { Observable, map } from "rxjs"
import { print } from "graphql"
import { generateClient } from "aws-amplify/api"
import type { GraphQLSubscription } from "aws-amplify/api"

/**
 * Bridges GraphQL subscription operations onto Amplify's AppSync realtime
 * transport. Amplify speaks AppSync's proprietary WebSocket protocol (handshake
 * auth + start/data/ka framing) natively and uses browser-native encoding, so
 * no Node Buffer polyfill is needed — unlike the generic graphql-ws client,
 * which AppSync rejects at the WS upgrade.
 *
 * Both Amplify v6 and Apollo Client 4 emit RxJS Observables, so the bridge is a
 * straight pass-through that reshapes Amplify's { data } messages into Apollo's
 * result shape. Queries/mutations stay on the HTTP link (see ApolloClientProvider).
 */
const client = generateClient()

export const amplifySubscriptionLink = new ApolloLink((operation) =>
  (
    client.graphql<GraphQLSubscription<Record<string, unknown>>>({
      query: print(operation.query),
      variables: operation.variables
    }) as Observable<{ data: Record<string, unknown> }>
  ).pipe(map((message): ApolloLink.Result => ({ data: message.data })))
)
